module.exports = __webpack_public_path__ + "static/Wei_Xu_headshot_lores-e25bd7f97f1a021e0ae97e8d7ddd02f5.png";